import {ActionType, ActionData} from './actions/ActionTypes';

export interface Action 
{
    actionType: ActionType,
    data?: ActionData.Base
}

export type DispatcherCallback = (action: Action) => void;

export module DispatcherModule 
{
    interface Listener {
        context: any,
        callback: DispatcherCallback, 
        priority: Priority, 
    }
    
    export enum Priority {
        HIGH, 
        NORMAL, 
        LOW, 
    }   
    
    export class Dispatcher 
    {
        private listeners: Array<Listener> = []

        subscribe(context: any, callback: DispatcherCallback, priority: Priority = Priority.NORMAL) 
        {
            this.listeners.push({ context: context, callback: callback, priority })
        }

        dispatch(action: Action) 
        {
            this.log(action);

            for (var priority of Object.keys(Priority).map(v => parseInt(v, 10)).filter(v => !isNaN(v)).sort()) {                
                for (var listener of this.listeners) {
                    if(priority === listener.priority) {                
                        listener.callback.call(listener.context, action) 
                    }
                }   
            }            
        }

        private log(action: Action)
        {
            var data = action.data ?
                    "data: " + action.data.toString() :
                    "no arguments";;
            
            console.info(`Dispatching action of type ${ActionType[action.actionType]} with ${data}`);
        }
    }
}

export var Dispatcher = new DispatcherModule.Dispatcher()


// WEBPACK FOOTER //
// ./Scripts/Dispatcher.ts